import * as react from "react";

export function userDialog(headerElement, bodyElements, footerElements) {
    let children_10, children_4;
    const children_12 = [react.createElement("div", {
        className: "modal-background",
    }), (children_10 = [(children_4 = [react.createElement("p", {
        className: "modal-card-title",
    }, headerElement)], react.createElement("header", {
        className: "modal-card-head",
    }, ...children_4)), react.createElement("section", {
        className: "modal-card-body overflow-initial",
    }, ...bodyElements), react.createElement("footer", {
        className: "modal-card-foot",
    }, ...footerElements)], react.createElement("div", {
        className: "modal-content overflow-initial",
    }, ...children_10))];
    return react.createElement("div", {
        className: "modal is-active is-wide",
    }, ...children_12);
}

//# sourceMappingURL=Modal.fs.js.map
